import AsyncStorage from "@react-native-async-storage/async-storage";
import AxiosService from "services/base/Axios.service";

export async function authHeader() {
  const accessToken = await AsyncStorage.getItem("userToken");
  return { "x-access-token": accessToken };
}

export default class AjaxService {
  async defaultConfig() {
    return { headers: await authHeader() };
  }

  get shouldExtractResponseData() {
    return true;
  }

  async get(url, config = {}) {
    return this._doRequest(AxiosService.get, url, config);
  }

  async post(url, data = {}, config = {}) {
    return this._doRequest(AxiosService.post, url, config, data);
  }

  async put(url, data = {}, config = {}) {
    return this._doRequest(AxiosService.put, url, config, data);
  }

  async delete(url, config = {}) {
    return this._doRequest(AxiosService.delete, url, config);
  }

  _formatResponse(response) {
    if (this.shouldExtractResponseData) {
      return {
        ...response.data,
        status: response.status,
        statusText: response.statusText,
      };
    }
    return response;
  }

  async _doRequest(axiosMethod, url, customConfig = {}, data = null) {
    try {
      const authHeaderToken = await authHeader();
      const config = { ...customConfig, headers: authHeaderToken };
      const res = await (data
        ? axiosMethod(url, data, config)
        : axiosMethod(url, config));
      return this._formatResponse(res);
    } catch (error) {
      // Handle 350 status code as a normal response
      if (error.response?.status === 350) {
        return this._formatResponse(error.response);
      }
      // Re-throw all other errors
      throw error;
    }
  }
}
